import React, { lazy } from "react";
import { Route, Navigate } from "react-router-dom";
import SecureLS from "secure-ls";

const ls = new SecureLS({ isCompression: false });
const AdminLogin = lazy(() => import("./Auth/AdminLogin"));
const AdminLayout = lazy(() => import("./Admin/AdminLayout"));
const AdminDashboard = lazy(() => import("./Admin/AdminDashboard"));
const AdminUsers = lazy(() => import("./Admin/AdminUsers"));
const AdminNotifications = lazy(() => import("./Admin/AdminNotifications"));
const AdminNPCs = lazy(() => import("./Admin/AdminNPCs"));
const AdminLogs = lazy(() => import("./Admin/Logs/AdminLogs"));
const AdminBugs = lazy(() => import("./Admin/AdminBugs"));
const AdminMarketListings = lazy(() => import("./Admin/AdminMarketListings"));
const UserInventory = lazy(() => import("./Admin/Users/Inventory/UserInventory"));
const UserCardInventory = lazy(() => import("./Admin/Users/Cards/UserCardInventory"));
const UserPlot = lazy(() => import("./Admin/Users/Plots/UserPlots"));
const UserSkills = lazy(() => import("./Admin/Users/Skills/UserSkills"));
const UserShops = lazy(() => import("./Admin/Users/Shops/UserShops"));
const AdminItems = lazy(() => import("./Admin/Assets/Items/AdminItems"));
const AdminTrees = lazy(() => import("./Admin/Assets/Trees/AdminTrees"));
const AdminRecipes = lazy(() => import("./Admin/Assets/Recipes/AdminRecipes"));
const AdminSkills = lazy(() => import("./Admin/Assets/Skills/AdminSkills"));
const AdminDungeons = lazy(() => import("./Admin/Assets/Dungeons/AdminDungeons"));
const AdminLocations = lazy(() => import("./Admin/Assets/Locations/AdminLocations"));
const AdminShop = lazy(() => import("./Admin/Assets/Shop/AdminShop"));
const AdminLeaderboard = lazy(() => import("./Admin/Leaderboard/AdminLeaderboard"));
const AdminCards = lazy(() => import("./Admin/Assets/Cards/AdminCards"));
const AdminCardPacks = lazy(() => import("./Admin/Assets/Cards/AdminCardPacks"));
const AdminDailyLogin = lazy(() => import("./Admin/DailyLogin/AdminDailyLogin"));

const hasAdminAccess = () => {
  const adminDetails = ls.get("adminDetails");
  return Boolean(adminDetails?.token) && adminDetails?.role === "admin";
};

const AdminLoginRoute = () => {
  return hasAdminAccess() ? (
    <Navigate to="/admin/dashboard" replace />
  ) : (
    <AdminLogin />
  );
};

const ProtectedAdminRoute = () => {
  return hasAdminAccess() ? (
    <AdminLayout />
  ) : (
    <Navigate to="/admin/login" replace />
  );
};

export const AdminRoutes = () => {
  return [
    <Route
      key="login"
      path="/admin/login"
      element={<AdminLoginRoute />}
    />,
    <Route
      key="admin"
      path="/admin"
      element={<ProtectedAdminRoute />}
    >
      <Route index element={<Navigate to="/admin/dashboard" replace />} />
      <Route path="dashboard" element={<AdminDashboard />} />
      <Route path="users" element={<AdminUsers />} />
      <Route path="npcs" element={<AdminNPCs />} />
      <Route path="users/inventory/:userId" element={<UserInventory />} />
      <Route path="users/cards/:userId" element={<UserCardInventory />} />
      <Route path="users/plots/:userId" element={<UserPlot />} />
      <Route path="users/skills/:userId" element={<UserSkills />} />
      <Route path="users/shops/:userId" element={<UserShops />} />
      <Route path="leaderboard" element={<AdminLeaderboard />} />
      <Route path="assets/items" element={<AdminItems />} />
      <Route path="assets/trees" element={<AdminTrees />} />
      <Route path="assets/recipes" element={<AdminRecipes />} />
      <Route path="assets/skills" element={<AdminSkills />} />
      <Route path="assets/dungeons" element={<AdminDungeons />} />
      <Route path="assets/cards" element={<AdminCards />} />
      <Route path="assets/card-packs" element={<AdminCardPacks />} />
      <Route path="assets/locations" element={<AdminLocations />} />
      <Route path="assets/shop" element={<AdminShop />} />
      <Route path="notifications" element={<AdminNotifications />} />
      <Route path="daily-login" element={<AdminDailyLogin />} />
      <Route path="logs" element={<AdminLogs />} /> 
      <Route path="bugs" element={<AdminBugs />} /> 
      <Route path="market-listings" element={<AdminMarketListings />} /> 
    </Route>,
  ];
};
